import { NavLink } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from './AuthWrapper';
import logo from './assets/images/S+ALogo.png';

function Navbar() {
  const { roles } = useContext(UserContext);

  return (
    <nav style={{
      display: 'flex',
      alignItems: 'center',
      gap: '2rem',
      padding: '1rem',
      borderBottom: '1px solid #444',
    }}>
      <img src={logo} alt="Slate + Ash" style={{ height: '80px' }} />

      <NavLink to="/" className="nav-link">Dashboard</NavLink>
      {roles.includes('admin') && <NavLink to="/admin" className="nav-link">Admin</NavLink>}
      {roles.includes('developer') && <NavLink to="/developer" className="nav-link">Developer</NavLink>}
      {roles.includes('developer') && <NavLink to="/health" className="nav-link">System Health</NavLink>}
    </nav>
  );
}

export default Navbar;
